// 관리자 로그아웃
import { CommonResponse, post } from './common.ts'

// POST /admin/logout

export const postAdminLogout = async (): Promise<CommonResponse<null>> => {
  return await post('/admin/logout', {})
}
